import React, { ReactElement, useContext } from 'react'

import Fieldset from '../../Common/Components/Fieldset'
import FormRow from '../../Common/Components/FormRow'
import Heading from '../../Common/Components/Heading'
import P from '../../Common/Components/P'
import Label from '../../Common/Components/Label'

import { LanguageContext } from '../../Common/Contexts'

import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { ScheduleStatus as ScheduleStatusLanguage } from '../../../../i18n'
import { HeadingLevel } from '../../Common/Components/Heading/Heading'

/**
 * Component properties type.
 */
type Props = {
    nextRunningAt: string
    lastRunAt: string
    statusError: string
}

/**
 * Schedule status section in scheduling tab of report configuration modal window.
 *
 * @param nextRunningAt
 * @param lastRunAt
 * @param statusError
 */
const ScheduleStatus: React.FC<Props> = ({ nextRunningAt, lastRunAt, statusError }: Props): ReactElement => {
    const language = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle('ScheduleStatus')

    return (
        <Fieldset className='schedule-status'>
            <Heading level={HeadingLevel.ONE}>
                {language.get(ScheduleStatusLanguage.ScheduleStatus_SectionHeader)}
            </Heading>
            <FormRow isInline className={'next-run-at'}>
                <Label>{language.get(ScheduleStatusLanguage.NextrunningatLabel)}</Label>
                <P>{nextRunningAt}</P>
            </FormRow>
            <FormRow isInline className={'last-run-at'}>
                <Label>{language.get(ScheduleStatusLanguage.LastrunatLabel)}</Label>
                <P>{lastRunAt}</P>
            </FormRow>
            <FormRow isInline className={'status-error'}>
                <Label>{language.get(ScheduleStatusLanguage.StatuserrorLabel)}</Label>
                <P>{statusError}</P>
            </FormRow>
        </Fieldset>
    )
}

export default ScheduleStatus
